module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/person2-b61bcfaa8cf80e882ce4ddbbc06dba05.png";